export function generateRandomHSN() {
  // Generate a 6-digit number
  const code = Math.floor(100000 + Math.random() * 900000);
  return code.toString();
}

export function generateInternalReference() {
  const prefix = "PRD"; // You can change if needed
  const category = "CTN"; // You can randomize categories if you want
  const number = Math.floor(1 + Math.random() * 999)
    .toString()
    .padStart(3, "0"); // 001 to 999
  return `${prefix}-${category}-${number}`;
}
